module.exports = __webpack_public_path__ + "static/media/SC-child-wheelchair.d37969a0.svg";